import { useEffect, useRef } from 'react';
import './FieldHeadersRow.scss';

export default function FieldHeadersRow({ fields, scrollRef }) {
  const headersRef = useRef(null);

  useEffect(() => {
    const content = scrollRef.current;
    const headers = headersRef.current;
    if (!content || !headers) return;
    const sync = () => {
      headers.scrollLeft = content.scrollLeft;
    };
    content.addEventListener('scroll', sync, { passive: true });
    return () => content.removeEventListener('scroll', sync);
  }, [scrollRef]);

  return (
    <div className='field-headers-row' ref={headersRef}>
      <div className='timeline-header-spacer' />
      <div className='field-names-wrap'>
        {fields.map((f) => (
          <h6 key={f.id} className='field-name-header'>
            {f.name}
          </h6>
        ))}
      </div>
    </div>
  );
}
